// conditionally loads the actual NewRelic script
export namespace NewRelic {
  export const init = (disable: boolean): void => {
    if (!disable) {
      // we use CommonJS require statement here due to NewRelic's implicit globals,
      // webpack bundling, and es module syntax current limitations for conditional imports
      require('./NewRelicScript.js')
    }
  }
}
